<template>
    <section class="page-content special">
        <header-inner/>

        <wrapper :lineBorders="false" :lineCenter="true">

          <products-menu @currentMenu="currentMenu($event)"/>

            <section class="content-one desktop" >
                <div class="text" v-if="specInfo" v-html="specInfo.description"></div>
            </section>
          <no-ssr>
            <section class="slider-section" v-if="specInfo.slider.length">
                <slider :autoplay="false" :arrows="true" ref="slider">
                    <image-slide :size="50" v-for="(slide, key) in specInfo.slider" :key="key" :image="slide.image"/>
                </slider>
            </section>
          </no-ssr>
        </wrapper>
      <wrapper :lineBorders="false" :lineCenter="true" class="mobile">
        <section class="content-one">
          <div class="text" v-if="specInfo" v-html="specInfo.description"></div>
        </section>
      </wrapper>
        <section class="content-info content-section">
            <wrapper>
                <h2 class="text-center title" v-html="specTitle"></h2>

                <div class="row-grid content_icons">
                    <div class="col-md-6 item" v-if="specList" :key="index"   v-for="(item,index) in specList">
                        <div class="icons big_title upper icons_svg" :class="item.code" v-html="item.title"></div>
                        <div class="description-item" v-if="item.preview_text" v-html="item.preview_text"></div>
                    </div>

                </div>
              <div class="buttons text-center">
<!--                <a href="http://www.russairport.ru/" target="_blank" class="btn solid&#45;&#45;green large">подробнее</a>-->
              </div>
<!--                <div class="description-bottom"><b>Для приобретения данного предложения или консультации по интересующим вопросам воспользуйтесь формой <a href="#" class="solid blue">обратной связи.</a></b></div>-->
            </wrapper>
        </section>

        <section class="block-content content-section"  v-if="titleCase">
            <wrapper>
              <h3 class="text-center big-title" v-html="titleCase.block_title"></h3>
              <no-ssr>
              <slider :autoplay="false" :arrows="true" ref="slider" v-if="this.$store.state.content.entities.best2special.loaded">
                <video-slide v-if="slide.video_link" v-for="(slide, key) in videoCase" :key="key" :video="videoYoutube(slide.video_link)"/>
              </slider>
              </no-ssr>
            </wrapper>
        </section>

    </section>
</template>

<script>
    import HeaderInner from '~/components/header/HeaderInner'
    import StringMixin from "../../components/shared/mixins/StringMixin";
  //  import Slider from "../../components/shared/sliders/Slider";
    import ImageSlide from "../../components/shared/sliders/ImageSlide";
    import ProductsMenu from "../../components/products/ProductsMenu";
    import CardBox from "../../components/shared/cards/CardBox";
    import ScreenMixin from "../../components/shared/mixins/ScreenMixin";
    import VideoSlide from "../../components/shared/sliders/VideoSlide";

    export default {

        mixins: [StringMixin,ScreenMixin],
        data() {
            return {
                slides: [
                    {
                        image: '/images/_tmp/2.jpg'
                    },
                    {
                        image: '/images/_tmp/3.jpg'
                    },
                ],
                seoMenu: {
                  title: 'Special',
                  description: null,
                  keywords: null,
                },
            };
        },
      // SEO API
        async asyncData({ $axios, app, route, redirect, store, query }) {
          await Promise.all([
            store.dispatch('content/loadInfoProds','spec'),
              store.dispatch('content/loadInfoProds','specbenefits'),
            store.dispatch('content/loadEntities', { sID: 'specbenefits',type:'content'}),
            store.dispatch('content/setTitle','best2special'),
            store.dispatch('content/loadEntities', { sID: 'best2special' }),
          ]);
            let seoPage = {}
            try {
                seoPage = await $axios.$get(`${process.env.apiUrl}/methods/site/get_page_info/?link=${route.path}`,
                    {
                        timeout: 1000 * 5, // Wait for 5 seconds
                    }
                );
                return {seoPage}
            } catch (e) {
                seoPage = {id:  '', title: '', description: '', keywords: ''}
                return {seoPage};
            }
        },
        head () {
          if(this.seoPage) {
            return {
              title: this.seoPage.title,
              link: [{rel: 'canonical', href: process.env.base + this.$route.path}],
              meta: [
                {
                  hid: `description`,
                  name: `description`,
                  content: this.seoPage.description
                },
                {
                  hid: `keywords`,
                  name: 'keywords',
                  content: this.seoPage.keywords
                }
              ]
            }
          }
        },
        computed: {
            specTitle() {
                return this.$store.state.content.infoProds.specbenefits.title;
            },
            specInfo() {
              return this.$store.state.content.infoProds.spec;
            },
            specList() {
              return  this.$store.state.content.entities.specbenefits.items
            },
            titleCase() {
              return  this.$store.state.content.titles.best2special
            },
            videoCase ()  {
              return  this.$store.state.content.entities.best2special.items
            }
        },
        mounted() {
           //  if(!this.specInfo.loaded) this.$store.dispatch('content/loadInfoProds','spec');
           //  if(!this.$store.state.content.entities.specbenefits.loaded) this.$store.dispatch('content/loadEntities', { sID: 'specbenefits',type:'content'});
           //  if(!this.$store.state.content.titles.best2special.loaded) this.$store.dispatch('content/loadTitle','best2special');
          //   if(!this.$store.state.content.entities.best2special.loaded) this.$store.dispatch('content/loadEntities', { sID: 'best2special' });

        },
        methods: {
          currentMenu(event) {
            this.seoMenu.title = event.title
            this.seoMenu.description = event.description
            this.seoMenu.keywords = event.keywords
          }
        },
        watch: {
            slides() {
                this.$refs.slider.rebuild();
            },
        },
        components: {
            HeaderInner,
       //     Slider,
            ImageSlide,
            ProductsMenu,
            CardBox,
            VideoSlide
        }
    }
</script>

<style lang="scss">

    //  @import "../../../assets/vars", "../../../assets/mixins";
    .slider-section {
        padding: 0px 0px 90px;
    }
    @media (max-width: $media_xs) {
      .slider-section {
        padding: 0px 0px 5px;
      }
    }
    .special {
      .content-info {
        padding-bottom: 60px;
        padding-top: 60px;
      }
      .buttons {
         margin-top: 30px;
      }
    }

</style>



// WEBPACK FOOTER //
// pages/products/special.vue